// Listes de comptes par sens (A1b-2, 03/11/2026).
// Crédit (entrée d'argent) : clients (411) ; débit (sortie) : fournisseurs (401)
// et charges (6) ; des deux côtés, « Autres opérations » (associés 455,
// personnel 421, État et TVA 44x, produits et charges financiers 76/66,
// virements entre banques 580, attente 471). « Autre sens » sur demande :
// remboursement d'un fournisseur (crédit) ou d'un client (débit). Les comptes
// proposés sont ceux de la liste fournie (plan de la société et tiers).
const startsWith = (c, prefixes) => prefixes.some(p => String(c.account_code).startsWith(p));
export const OTHER_OPERATIONS = ["455", "421", "44", "76", "66", "580", "471"];
const isClient = (c) => c.kind === "client" || (c.kind === "sans_fiche" && startsWith(c, ["411"]));
const isSupplier = (c) => c.kind === "fournisseur" || (c.kind === "sans_fiche" && startsWith(c, ["401"]));
const isOther = (c) => c.kind === "general" && startsWith(c, OTHER_OPERATIONS);
const isCharge = (c) => c.kind === "general" && startsWith(c, ["6"]) && !startsWith(c, ["66"]);

/** Groupes du champ de compte d'une ligne du relevé : 'credit' (entrée) ou 'debit' (sortie). */
export function bankLineGroups(direction) {
  if (direction === "credit") {
    return {
      groups: [{ title: "Clients (411)", test: isClient }, { title: "Autres opérations", test: isOther }],
      otherGroup: { title: "fournisseurs (remboursement)", test: isSupplier },
    };
  }
  return {
    groups: [{ title: "Fournisseurs (401)", test: isSupplier }, { title: "Charges (6)", test: isCharge }, { title: "Autres opérations", test: isOther }],
    otherGroup: { title: "clients (avoir, remboursement)", test: isClient },
  };
}

/** Compte de charge d'un achat (« Corriger ») : charges (6) et immobilisations (2) du plan. */
export const purchaseAccountGroups = {
  groups: [{ title: "Charges (6)", test: (c) => c.kind === "general" && startsWith(c, ["6"]) }, { title: "Immobilisations (2)", test: (c) => c.kind === "general" && startsWith(c, ["2"]) }],
  otherGroup: null,
};

/** Comptes de produit d'une vente : ventes (70) et autres produits (75). */
export const salesAccountGroups = {
  groups: [{ title: "Ventes (70)", test: (c) => c.kind === "general" && startsWith(c, ["70"]) }, { title: "Autres produits (75)", test: (c) => c.kind === "general" && startsWith(c, ["751", "752", "758"]) && !startsWith(c, ["7586"]) }],
  otherGroup: null,
};
